export default "__VITE_ASSET__D3Rkm55a__"